module.exports = __webpack_public_path__ + "media/images/fallback/user_review/thumb-603fb7dbd5400cbee27713cc977f4d28.webp";